import { render, staticRenderFns } from "./InputSwitch.vue?vue&type=template&id=0a076c33&scoped=true&"
import script from "./InputSwitch.vue?vue&type=script&lang=ts&"
export * from "./InputSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./InputSwitch.vue?vue&type=style&index=0&id=0a076c33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a076c33",
  null
  
)

export default component.exports